/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="83.97" height="94.33" viewBox="0 0 83.97 94.33" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g>
      <g>
        <polygon points="42.82 26.21 42.82 28.71 30.48 28.71 30.48 94.33 27.98 94.33 27.98 26.21 42.82 26.21" fill="#ffb81c"/>
      </g>
      <g>
        <polygon points="24.6 51.26 24.6 53.76 16.49 53.76 16.49 94.33 13.99 94.33 13.99 51.26 24.6 51.26" fill="#ffb81c"/>
      </g>
      <g>
        <polygon points="10.64 76.31 10.64 78.81 2.5 78.81 2.5 94.33 0 94.33 0 76.31 10.64 76.31" fill="#ffb81c"/>
      </g>
    </g><path d="M101,123.83v0Z" transform="translate(-35.5 -29.5)" fill="#0d5383" fillRule="evenodd"/><polygon points="66.7 82.94 66.7 94.33 64.2 94.33 64.2 82.94 66.7 82.94" fill="#0e497b"/><path d="M101,112.44v0Z" transform="translate(-35.5 -29.5)" fill="#0d5383" fillRule="evenodd"/><path d="M101,89.08a1.24,1.24,0,0,1,1.24,1.12v22.23a1.25,1.25,0,0,1-2.49.13V90.33A1.25,1.25,0,0,1,101,89.08Z" transform="translate(-35.5 -29.5)" fill="#0e497b"/><path d="M91.56,123.83v0Z" transform="translate(-35.5 -29.5)" fill="#0d5383" fillRule="evenodd"/><polygon points="57.31 82.94 57.31 94.33 54.81 94.33 54.81 82.94 57.31 82.94" fill="#0e497b"/><path d="M91.56,112.44v0Z" transform="translate(-35.5 -29.5)" fill="#0d5383" fillRule="evenodd"/><path d="M91.56,67.75a1.25,1.25,0,0,1,1.24,1.12v43.57a1.25,1.25,0,0,1-1.25,1.25,1.27,1.27,0,0,1-1.25-1.13V69A1.25,1.25,0,0,1,91.56,67.75Z" transform="translate(-35.5 -29.5)" fill="#0e497b"/><g>
      <path d="M108.07,52.32a11.4,11.4,0,0,1,11.39,11.11V88a3.89,3.89,0,0,1-3.68,3.68h-5.43a1.25,1.25,0,0,1-.13-2.5h5.35A1.39,1.39,0,0,0,117,87.88V63.72a8.91,8.91,0,0,0-8.64-8.89H93.83a8.91,8.91,0,0,0-8.89,8.64V87.75a1.39,1.39,0,0,0,1.25,1.38h5.37a1.25,1.25,0,0,1,.12,2.49H86.33A3.9,3.9,0,0,1,82.44,88V63.72a11.39,11.39,0,0,1,11.1-11.39h14.53Z" transform="translate(-35.5 -29.5)" fill="#0e497b"/>
      <g>
        <line x1="74.85" y1="82.94" x2="74.85" y2="94.33" fill="none"/>
        <polygon points="76.1 82.94 76.1 94.33 73.6 94.33 73.6 82.94 76.1 82.94" fill="#0e497b"/>
      </g>
      <g>
        <line x1="74.85" y1="39.5" x2="74.85" y2="82.94" fill="none"/>
        <path d="M110.35,67.75a1.25,1.25,0,0,1,1.24,1.12v43.57a1.25,1.25,0,0,1-1.25,1.25,1.27,1.27,0,0,1-1.25-1.13V69A1.25,1.25,0,0,1,110.35,67.75Z" transform="translate(-35.5 -29.5)" fill="#0e497b"/>
      </g>
      <path d="M101,29.5a9.83,9.83,0,1,0,9.82,9.83A9.83,9.83,0,0,0,101,29.5Zm0,2.5a7.33,7.33,0,1,1-7.33,7.33A7.33,7.33,0,0,1,101,32Z" transform="translate(-35.5 -29.5)" fill="#0e497b"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'PersonWithPastGrowthHeightLinesIcon';

export default Icon;
